import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Box, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';

import { WorkspaceUsers } from '../../../mainApi';

type WorkspaceMembersCurrentProps = {
  users: WorkspaceUsers | null;
  isOwner: boolean;
  isSaving: boolean;
  onRemove: (userId: string) => void;
};

export const WorkspaceMembersCurrent = ({
  users,
  isOwner,
  isSaving,
  onRemove,
}: WorkspaceMembersCurrentProps) => (
  <>
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Owner
      </Typography>
      <List dense disablePadding>
        <ListItem sx={{ px: 0 }}>
          <ListItemText
            primary={users?.owner?.name || users?.owner?.email || 'Unknown owner'}
            secondary={users?.owner?.email}
          />
        </ListItem>
      </List>
    </Box>

    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Members
      </Typography>
      {users?.members?.length ? (
        <List dense disablePadding>
          {users.members.map((member, index) => (
            <ListItem
              key={member.id || member.email || `member-${index}`}
              sx={{ px: 0 }}
              secondaryAction={
                isOwner && member.id ? (
                  <IconButton
                    edge="end"
                    aria-label="remove member"
                    onClick={() => {
                      if (member.id) {
                        onRemove(member.id);
                      }
                    }}
                    disabled={isSaving}
                  >
                    <DeleteOutlineOutlinedIcon fontSize="small" />
                  </IconButton>
                ) : null
              }
            >
              <ListItemText
                primary={member.name || member.email || 'Unknown member'}
                secondary={member.email}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No members
        </Typography>
      )}
    </Box>

    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Pending invites
      </Typography>
      {users?.pending?.length ? (
        <List dense disablePadding>
          {users.pending.map((invite, index) => (
            <ListItem
              key={invite.id || invite.email || `pending-${index}`}
              sx={{ px: 0 }}
              secondaryAction={
                isOwner && invite.id ? (
                  <IconButton
                    edge="end"
                    aria-label="remove invite"
                    onClick={() => {
                      if (invite.id) {
                        onRemove(invite.id);
                      }
                    }}
                    disabled={isSaving}
                  >
                    <DeleteOutlineOutlinedIcon fontSize="small" />
                  </IconButton>
                ) : null
              }
            >
              <ListItemText primary={invite.email || 'Pending invite'} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No pending invites
        </Typography>
      )}
    </Box>
  </>
);
